import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/RedboxGlobalBeta.css';

const RedboxGlobalBeta = () => {
  return (
    <>
      <Helmet>
        <title>Redbox Global Beta - Experiments, Innovation & Early Access</title>
        <meta
          name="description"
          content="Redbox Global Beta explores experimental ideas, early-access initiatives, and innovation shaping the future of media, technology, and culture."
        />
        <meta
          name="keywords"
          content="beta, innovation lab, experimental projects, early access, emerging ideas, future concepts"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/beta" />
        <meta
          property="og:title"
          content="Redbox Global Beta - Experiments & Innovation"
        />
        <meta
          property="og:description"
          content="Inside Redbox Global’s experimental lab: bold ideas, early access, and future-facing projects."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&h=630&fit=crop"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Redbox Global Beta" />
        <meta
          name="twitter:description"
          content="Experimental ideas and early access from Redbox Global."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&h=630&fit=crop"
        />

        <link rel="canonical" href="https://redboxglobal.com/beta" />
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Redbox Global Beta</h1>
          <p className="page-subtitle">
            Experimental ideas, early access, and the future in progress
          </p>
        </div>

        <div className="page-content">
          {/* Featured Article */}
          <a
            href="/article/redbox-beta-innovation-lab"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&h=600&fit=crop"
                  alt="Redbox Global Beta innovation"
                />
              </div>
              <div className="featured-content">
                {/* <span className="article-category">Beta Launch</span> */}
                <h2>Inside Redbox Global Beta: Building the Future in Public</h2>
                <p>
                  A look into our experimental lab where ideas are tested,
                  refined, and released before the world sees them.
                </p>
                <span className="article-meta">Featured This Week</span>
              </div>
            </div>
          </a>

          {/* Article Grid */}
          <div className="content-grid">
            <a
              href="/article/early-access-platforms"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=600&h=400&fit=crop"
                    alt="Early access technology"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Early Access</span> */}
                  <h2>Why Early Access Is Reshaping Product Development</h2>
                  <p>
                    How releasing products early helps teams iterate faster and
                    build what users actually want.
                  </p>
                  <span className="article-meta">February 6, 2026</span>
                </div>
              </article>
            </a>

            <a
              href="/article/experimental-media-formats"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=600&h=400&fit=crop"
                    alt="Experimental media"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Experiments</span> */}
                  <h2>Testing New Media Formats in the Beta Era</h2>
                  <p>
                    From interactive storytelling to AI-generated content,
                    Beta allows us to experiment boldly.
                  </p>
                  <span className="article-meta">February 4, 2026</span>
                </div>
              </article>
            </a>

            <a
              href="/article/future-product-ideas"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=600&h=400&fit=crop"
                    alt="Future product ideas"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Concepts</span> */}
                  <h2>Concepts Today, Products Tomorrow</h2>
                  <p>
                    A glimpse at experimental ideas that could become Redbox
                    Global’s next flagship offerings.
                  </p>
                  <span className="article-meta">February 2, 2026</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default RedboxGlobalBeta;

